export const historyMovementsViewInitValue = {
  data: {
    expandView: false,
    expandDirection: 'down',
    historyMovements: [],
    operationType: '',
  },
  actions: {
    handleChangeExpandView: () => {},
  },
};
